/* eslint-disable @typescript-eslint/no-explicit-any */
import { InputGroup } from '@chakra-ui/react'
import React from 'react'
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

function PhoneReactInput(props: any, ref: any) {
  return (
    <ReactPhoneInput
      buttonStyle={{
        borderColor: 'none !important',
        border: '1px solid !important',
      }}
      inputStyle={{
        width: '100%',
        minWidth: '0px',
        outline: '2px solid transparent',
        outlineOffset: '2px',
        appearance: 'none',
        transitionProperty: 'var(--chakra-transition-property-common)',
        transitionDuration: 'var(--chakra-transition-duration-normal)',
        height: '50px',
        fontSize: 'var(--chakra-fontSizes-sm)',
        borderRadius: 'var(--chakra-radii-none) !important',
        fontWeight: 'var(--chakra-fontWeights-medium)',
        color: 'var(--chakra-colors-black-primary3)',
        paddingRight: 10,
        border: '1px solid',
        borderColor: 'var(--chakra-colors-black-primary3)',
      }}
      country={'tr'}
      ref={ref}
      {...props}
    />
  )
}

const CustomPhoneInput = React.forwardRef(PhoneReactInput)

function PhoneInput({ ...props }) {
  return (
    <InputGroup className="light-theme">
      <CustomPhoneInput {...props} />
    </InputGroup>
  )
}
export default PhoneInput
